import { createReducer, on } from '@ngrx/store';
import { appActions } from '../actions';

export const featureKey = 'app';

export const initialState: any = {
    isLoading: false
};

export const reducer = createReducer(
    initialState,
    on(appActions.setAppLoader, (state, { isLoading }) => ({ ...state, isLoading }))
);
